<template>
  <div class="form-field">

    <div class="form-field-label">{{ label }}</div>

    <div class="container-fluid mb-1 px-3">

      <Row>

        <Col class="col-3 col-md-2">
          <ValidationProvider :name="name + '.sku'" v-slot="{ errors }" persist>

            <label class="form-field-label" :for="name + '.sku'">SKU/PIP</label>
            <input class="form-control"
                   :name="name + '.sku'"

                   :value="value.sku"
                   @input="onInput('sku', $event.target.value)"
                   type="text"
            >

            <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>

          </ValidationProvider>
        </Col>

        <Col class="col-6 col-md-8">
          <ValidationProvider :name="name + '.desc'" v-slot="{ errors }" persist rules="required|min:4">

            <label class="form-field-label required" :for="name + '.desc'">Description</label>
            <input class="form-control"
                   :name="name + '.desc'"

                   :value="value.desc"
                   @input="onInput('desc', $event.target.value)"
                   type="text"
            >

            <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>

          </ValidationProvider>
        </Col>

        <Col class="col-2 col-md-1">
          <ValidationProvider :name="name + '.qty'" v-slot="{ errors }" persist rules="required|min_value:1">
            <label class="form-field-label required" :for="name + '.qty'">Devices</label>
            <select class="form-control"
                    :name="name + '.qty'"
                    :value="value.qty"
                    @input="onInput('qty', $event.target.value)"
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
            </select>
            <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>
          </ValidationProvider>
        </Col>

        <Col class="delete col-1">
          <div class="form-remove-product"
               @click.prevent="$emit('remove-product-line', $event.target.value)">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>
          </div>
        </Col>

      </Row>

    </div>

  </div>
</template>

<script>
import {ValidationProvider} from 'vee-validate'
import Row from "../layout/Row";
import Col from "../layout/Col";

export default {
  name: "ProductRepeaterItem",
  props: ["name", "value", "label"],
  components: {
    Row,
    Col,
    ValidationProvider
  },
  data() {
    return this.value || {
      sku: '',
      desc: '',
      qty: 0
    }
  },
  methods: {
    onInput: function (fieldName, value) {
      this.value[fieldName] = value
    }
  }
}
</script>

<style lang="scss" scoped>

.form-field-label {
  &.required {
    &:after {
      content: '*';
      color: red;
    }
  }
}

.col {
  padding-right: 5px;
  padding-left: 5px;

  .form-remove-product {
    color: $danger;
    margin-top: 1.60em;
    font-size: 1.5em;

    &:hover {
      cursor: pointer;
      opacity: 0.75;
    }
  }
}
</style>
